const fetchSmartDodosSsoLink: any = async () => {
  // POST: this mints a short-lived SmartDodos login token and must not be cached/prefetched.
  const { data, status, error }: any = await dataFetch("/smartdodos/sso-link", {
    method: "POST",
  });

  if (status.value === "error") {
    return {
      data: null,
      status,
      error: error.value,
    };
  }

  return {
    data: data.value,
    status,
    error: null,
  };
};

// Exchange a short-lived Ralph JWT server-side and open the SmartDodos dashboard.
// The tab is opened synchronously (within the click gesture) so popup blockers
// don't block it, then redirected once the login link is returned.
const openSmartDodosDashboard: any = async () => {
  const newTab = window.open("", "_blank");
  // Sever the opener so the SmartDodos tab can't reach back into this window.
  if (newTab) newTab.opener = null;

  const response = await fetchSmartDodosSsoLink();

  if (response.error || !response.data?.redirect_url) {
    if (newTab) newTab.close();
    return { success: false, error: response.error };
  }

  if (newTab) {
    newTab.location.href = response.data.redirect_url;
  } else {
    window.open(response.data.redirect_url, "_blank", "noopener");
  }

  return { success: true, error: null };
};

export { fetchSmartDodosSsoLink, openSmartDodosDashboard };
